<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';
import AddManagersModal from '@/components/forums/AddManagersModal';

export default {
    components: {
        AddManagersModal
    },

    extends: TableView,

    props: {
        forumId: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            includeHeader: false,
            includeDeleteAction: false
        };
    },

    computed: {
        additionalFetchData() {
            return {
                forumId: this.forumId
            };
        },
        options() {
            return {
                addButton: false,
                selectField: 'id',
                clickableRows: false
            };
        },
        labels() {
            return [
                {
                    value: 'fullName',
                    width: '150px'
                },
                {
                    value: 'email',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'users/getManagers'
        })
    }
};
</script>
